import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img, { FluidObject } from "gatsby-image";

type Data = {
  data: {
    placeholderImage: {
      childImageSharp: {
        fluid: FluidObject;
      };
    };
  };
};

/** Refer to https://www.gatsbyjs.org/packages/gatsby-image/#gatsby-image-props for props */
export const PureAppScreenImage: React.FC<Data> = ({ data, ...attrs }) => {
  return (
    <Img
      fluid={data.placeholderImage.childImageSharp.fluid}
      alt="An image of an AppScreen"
      className="relative rounded-lg shadow-lg"
      {...attrs}
    />
  );
};

const AppScreenImage: React.FC = ({ ...attrs }) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "app-screen-3-half.png" }) {
        childImageSharp {
          fluid(maxWidth: 3244) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return <PureAppScreenImage data={data} {...attrs} />;
};

export default AppScreenImage;
